import { FC } from "react";
import { Button, ButtonProps } from "@mui/material";

type Props = ButtonProps & {
  children: React.ReactNode;
  component?: React.ElementType;
  category: string;
  value: string;
};

export const TabButtonPatient: FC<Props> = ({
  category,
  value,
  children,
  ...rest
}) => (
  <Button
    variant="outlined"
    size="large"
    sx={[
      {
        borderRadius: "10px",
        fontWeight: "600",
        textTransform: "capitalize",
        backgroundColor: category === value ? "black" : "initial",
        color: category === value ? "#E8F3FF" : "initial",
      },
      {
        "&:hover": {
          backgroundColor: "initial",
          color: "initial",
        },
      },
    ]}
    {...rest}
  >
    {children}
  </Button>
);
